// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__qN2No","itemA":"Write_itemA__14BM6","itemB":"Write_itemB__1DbuC","itemC":"Write_itemC__1exbp","itemD":"Write_itemD__R3bNn"};